import { TDWOperationType, TDWActionType, TDWModuleType, EventCodeType, TDWVer8Type } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';

const COMMON_REPORT_INFO = {
    opername: TDWOperationType.DOC_PPT,
    module: TDWModuleType.SELECT_PANEL,
};
export const SELECT_WINDOW_REPORT = {
    open: {
        ...COMMON_REPORT_INFO,
        action: TDWActionType.SELECT_OPEN,
        eventcode: EventCodeType.DOC_PPT_SELECT_PANEL_OPEN,
    },
    showAll: {
        ...COMMON_REPORT_INFO,
        action: TDWActionType.SHOW_ALL,
        eventcode: EventCodeType.DOC_PPT_SELECT_PANEL_SHOW_ALL,
    },
    hideAll: {
        ...COMMON_REPORT_INFO,
        action: TDWActionType.HIDE_ALL,
        eventcode: EventCodeType.DOC_PPT_SELECT_PANEL_HIDE_ALL,
    },
    hideOne: {
        ...COMMON_REPORT_INFO,
        action: TDWActionType.HIDE_ONE,
        eventcode: EventCodeType.DOC_PPT_SELECT_PANEL_HIDE_ONE,
    },
    showOne: {
        ...COMMON_REPORT_INFO,
        action: TDWActionType.SHOW_ONE,
        eventcode: EventCodeType.DOC_PPT_SELECT_PANEL_SHOW_ONE,
    },
    unFoldGroup: {
        ...COMMON_REPORT_INFO,
        action: TDWActionType.UNFOLD_GROUP,
        eventcode: EventCodeType.DOC_PPT_SELECT_PANEL_UNFOLD_GROUP,
    },
    foldGroup: {
        ...COMMON_REPORT_INFO,
        action: TDWActionType.FOLD_GROUP,
        eventcode: EventCodeType.DOC_PPT_SELECT_PANEL_FOLD_GROUP,
    },
    drag: {
        ...COMMON_REPORT_INFO,
        action: TDWActionType.SELECT_DRAG,
        eventcode: EventCodeType.DOC_PPT_SELECT_PANEL_DRAG,
    },
    setWidth: {
        ...COMMON_REPORT_INFO,
        action: TDWActionType.SET_WIDTH,
        eventcode: EventCodeType.DOC_PPT_SELECT_PANEL_SET_WIDTH,
    },
};

export const tdwReport = (reportInfo) => {
    tdw(reportInfo);
};
